module.exports = __webpack_public_path__ + "static/media/tommySleeveHood1.7f85ca3e.svg";